$( document ).ready( () => {
  let prevWidth = $( window ).width();

  // Switch to dropdown list
  if (prevWidth <= 768 && !$( '.sort-dropdown' ).hasClass( 'mobile' )) {
    $( '.sort-dropdown' ).addClass( 'ui mobile' );
  }
  // Switch from drodown list to flat div
  if (prevWidth > 768 && $( '.sort-dropdown' ).hasClass( 'mobile' )) {
    $( '.sort-dropdown' ).removeClass( 'ui mobile' );
    $( '.sort-dropdown .menu' ).removeClass( 'transition hidden' );
  }

  $( window ).resize( () => {
    const width = $( window ).width();
    // Switch from mobile to desktop version
    if (width > 768 && prevWidth <= 768 && $( '.header-wrapper' ).hasClass( 'open' )) {
      $( '.header-wrapper' ).removeClass( 'open' );
      $( '.hamburger .icon' ).removeClass( 'close' ).addClass( 'bars' );
      $( '.logo img' ).attr( 'src', './images/icons/logo.png' );
    }

    // Switch to dropdown list
    if (width <= 768 && !$( '.sort-dropdown' ).hasClass( 'ui' )) {
      $( '.sort-dropdown' ).addClass( 'ui mobile' );
    }
    // Switch from drodown list to flat div
    if (width > 768 && $( '.sort-dropdown' ).hasClass( 'ui' )) {
      $( '.sort-dropdown' ).removeClass( 'ui mobile' );
      $( '.sort-dropdown .menu' ).removeClass( 'transition hidden' );
    }

    prevWidth = width;
  } );

  const years = [];
  const currentYear = Number( new Date().getFullYear() );

  for (let i = currentYear; i >= 1900; i--) {
    years.push( { name: i, value: i } );
  }
  $( '.manufacturer-dropdown' ).dropdown();
  $( '.model-dropdown' ).dropdown();
  $( '.year-dropdown' ).dropdown( {
    values: years,
    placeholder: 'Select Year'
  } );
  $( '.from-suburb-dropdown' ).dropdown();
  $( '.to-suburb-dropdown' ).dropdown();
  $( '.payment-way .ui.radio' ).checkbox();
  $( '.custom-radio' ).checkbox();
  $( '.custom-radio.default-checked' ).checkbox( 'check' );
  $( '.custom-checkbox' ).checkbox();

  // Testimonials slider
  $( '.testimonials-slider.owl-carousel' ).owlCarousel( {
    items: 3,
    dots: true,
    dotsEach: true,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      800: {
        items: 3
      }
    }
  } );

  // Open popup with form
  $( document ).on( 'click', '.quote', () => {
    $( '.quote-form-popup' ).modal( {
      autofocus: false,
      observeChanges: true
    } ).modal( 'show' );
  } );

  // Open send mail popup
  $( document ).on( 'click', '.send-mail a', () => {
    $( '.send-mail-popup' ).modal( 'show' );
  } );

  // Open important info popup
  $( document ).on( 'click', '.important-info span', () => {
    $( '.important-info-popup' ).modal( 'show' );
  } );

  // Close popup with form
  $( document ).on( 'click', '.quote-form-popup .close-popup span', () => {
    $( '.quote-form-popup' ).modal( 'hide' )
  } );

  // Close send mail popup
  $( document ).on( 'click', '.send-mail-popup .close-popup span', () => {
    $( '.send-mail-popup' ).modal( 'hide' )
  } );

  // Close important info popup
  $( document ).on( 'click', '.important-info-popup .close-popup span', () => {
    $( '.important-info-popup' ).modal( 'hide' )
  } );

  // Switch routes on the map
  $( document ).on( 'click', '.routes-list ul li', ( event ) => {
    const self = event.currentTarget;
    if (!$( self ).hasClass( 'active' )) {
      const cls = `.${self.className}`;

      // Clone element to restart animation
      const elm = $( '.svg-map svg path' + cls );
      const newone = elm.clone( true );
      elm.before( newone );
      elm.remove();

      $( '.routes-list ul li' ).removeClass( 'active' );
      $( self ).addClass( 'active' );
      $( '.svg-map svg g use' ).hide();
      $( '.svg-map svg g use' + cls ).show();
    }
  } );

  $( '.checkbox.drivable' ).checkbox( 'check' );
  $( '.checkbox.modifications' ).checkbox();

  // Open mobile menu
  $( document ).on( 'click', '.hamburger .bars', () => {
    $( '.header-wrapper' ).addClass( 'open' );
    $( '.hamburger .icon' ).removeClass( 'bars' ).addClass( 'close' );
  } );

  // Close mobile menu
  $( document ).on( 'click', '.hamburger .close', () => {
    $( '.header-wrapper' ).removeClass( 'open' );
    $( '.hamburger .icon' ).removeClass( 'close' ).addClass( 'bars' );
  } );

  $( document ).on( 'click', '.static-call-for-quote .close i', () => {
    $( '.static-call-for-quote' ).hide();
  } );

  $( '.quotation-tab .item' ).tab();

  $( '.sort-dropdown' ).dropdown();

  // Select one quote on the quotation page
  $( document ).on( 'click', '.quote-result .button.select', ( event ) => {
    $( '.quote-result.selected' ).removeClass( 'selected' );
    $( event.currentTarget ).parents( '.quote-result' ).addClass( 'selected' );
  } );

  // Show or hide the form depending on the value of the checkbox
  $( document ).on( 'change', '.quote-form-popup .custom-toggle-checkbox.modifications input', () => {
    if ($( '.quote-form-popup .form-field.details-of-modification' ).hasClass( 'hidden' )) {
      $( '.quote-form-popup .form-field.details-of-modification' ).removeClass( 'hidden' );
    } else {
      $( '.quote-form-popup .form-field.details-of-modification' ).addClass( 'hidden' ).find( '.error-message' ).hide();
    }
  } );

  // Show or hide the form depending on the value of the checkbox
  $( document ).on( 'change', '.quote-form .custom-toggle-checkbox.modifications input', () => {
    if ($( '.quote-form .form-field.details-of-modification' ).hasClass( 'hidden' )) {
      $( '.quote-form .form-field.details-of-modification' ).removeClass( 'hidden' );
    } else {
      $( '.quote-form .form-field.details-of-modification' ).addClass( 'hidden' ).find( '.error-message' ).hide();
    }
  } );

  $( '.datepicker-here' ).datepicker( {
    language: 'en',
    autoClose: true,
    minDate: new Date(),
    dateFormat: 'mm/dd/yyyy'
  } );

  // Allow only digit input
  $( document ).on( 'keydown', 'input.only-digit', ( event ) => {
    if (!/^\d+$/.test( event.key )) {
      event.preventDefault();
      return false;
    }
  } )
} );
